import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, ParallaxImage } from "./Reveal";

export const SectionLabel = ({ children, dark = false, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    <span className={`h-px w-10 ${dark ? "bg-ivory/40" : "bg-ink/40"}`} />
    <span
      className={`text-[11px] font-medium uppercase tracking-[0.25em] ${
        dark ? "text-ivory/60" : "text-stone"
      }`}
    >
      {children}
    </span>
  </div>
);

export const CTAButton = ({ to, href, children, variant = "dark", testId, className = "", onClick }) => {
  const base =
    "group inline-flex items-center gap-3 px-7 py-3.5 text-[11px] font-medium uppercase tracking-[0.2em] transition-colors duration-500";
  const variants = {
    dark: "bg-ink text-ivory hover:bg-bronze",
    outline: "border border-ink/60 text-ink hover:bg-ink hover:text-ivory",
    light: "bg-ivory text-ink hover:bg-bronze hover:text-ivory",
    outlineLight: "border border-ivory/50 text-ivory hover:bg-ivory hover:text-ink",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowUpRight
        size={14}
        strokeWidth={1.5}
        className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </>
  );
  if (to)
    return (
      <Link to={to} data-testid={testId} className={cls} onClick={onClick}>
        {inner}
      </Link>
    );
  return (
    <a href={href} data-testid={testId} className={cls} onClick={onClick}>
      {inner}
    </a>
  );
};

export const PageHero = ({ kicker, lines, sub, image, imageAlt, dark = false }) => (
  <section className={dark ? "bg-ink text-ivory" : "bg-ivory text-ink"}>
    <div className="mx-auto max-w-7xl px-6 pt-36 pb-14 md:px-10 md:pt-48 md:pb-20">
      <SectionLabel dark={dark} className="mb-8 md:mb-12">
        {kicker}
      </SectionLabel>
      <h1 className="font-serif text-[13vw] leading-[1.02] font-light tracking-tight sm:text-6xl md:text-7xl lg:text-[5.5rem]">
        <MaskLines lines={lines} />
      </h1>
      {sub && (
        <p
          className={`mt-8 max-w-xl text-base leading-relaxed md:mt-10 md:text-lg ${
            dark ? "text-ivory/70" : "text-stone"
          }`}
        >
          {sub}
        </p>
      )}
    </div>
    {image && (
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <ParallaxImage src={image} alt={imageAlt} className="aspect-[16/9] w-full md:aspect-[21/9]" eager />
      </div>
    )}
  </section>
);
